import React, { useRef, useState, useContext } from 'react'
import { takeSignedOutReason } from './session'
import axios from 'axios'
import { UserContext } from './context/UserContext'
import { useNavigate } from 'react-router-dom'
import useTheme from './theme/useTheme'
import Btn from './ui/Btn'
import './login.css'


export default function Login() {
  const [loginError, setLoginError] = useState(false)
  /* Why the last session ended, if the API ended it. Read once. */
  const [signedOutReason] = useState(takeSignedOutReason)
  const [loginSuccess, setLoginSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [showPwd, setShowPwd] = useState(false)
  const { userName, setUserName } = useContext(UserContext)
  const { isAuth, setIsAuth } = useContext(UserContext)
  const { apiToken, setApiToken } = useContext(UserContext)
  const { userToken, setUserToken } = useContext(UserContext)

  const { isDark, toggle } = useTheme()

  const UN = useRef()
  const PWD = useRef()
  const navigate = useNavigate()

  const onToggleTheme = () => {
    toggle()
  }

  const login = (e) => {
    e.preventDefault()
    if (submitting) return

    const loginData = {
      UN: UN.current.value,
      PWD: PWD.current.value
    }

    setLoginError(false)
    setSubmitting(true)

    axios.post(process.env.REACT_APP_API_SERVER + 'admin/login', loginData, {})
      .then(res => {
        console.log(res.data)
        if (res.data.err == 0) {
          setIsLoading(true)
          validateUser(res.data, loginData.UN)

        } else {
          setIsAuth(false)
          // setUserToken(null)
          // setLoginSuccess(false)
          setLoginError(true)
          setSubmitting(false)
          setTimeout(() => {
            setLoginError(false)
          }, 3000);
        }
      })
      /* Rejection only — nothing here reads res.data, so the response contract is
         untouched. Without it a dropped connection would leave the button spinning. */
      .catch(() => {
        setLoginError(true)
        setSubmitting(false)
        setTimeout(() => {
          setLoginError(false)
        }, 3000);
      })

  }


  const validateUser = (data, submittedUN) => {
    /* admin/login returns { err, token, uid, isAdmin } — there is no UN in the
       response. The submitted username is the only source we have, and it is the
       right one: it is exactly the account that just authenticated. */
    const name = (submittedUN || '').trim()

    setIsAuth(true)
    setUserToken(data.id)
    setUserName(name)
    setLoginSuccess(true)
    setLoginError(false)
    setApiToken(data.token)

    sessionStorage.setItem('isAuth', 1)
    sessionStorage.setItem('userToken', data.id)
    sessionStorage.setItem('userUUID', data.uid)
    sessionStorage.setItem('userName', name)
    sessionStorage.setItem('apiToken', data.token)
    sessionStorage.setItem('clipBoard', { ContentID: 0, ContentTitle: '' })
    sessionStorage.setItem('isAdmin', data.isAdmin)
    setTimeout(() => {

      navigate('/dashboard')
    }, 3000);

  }

  return (
    <div className="lgn-wrap">
      <div className="lgn-top">
        <Btn className="lgn-theme" onClick={onToggleTheme} aria-label="Switch theme">
          {isDark ? (
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="4" />
              <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
            </svg>
          )}
          <span className="lgn-theme-label">{isDark ? 'Light' : 'Dark'}</span>
        </Btn>
      </div>

      <main className="lgn-main">
        <section className="lgn-card" aria-labelledby="lgn-title">
          <header className="lgn-brand">
            <img
              className="lgn-mark"
              src={process.env.PUBLIC_URL + '/logo.png'}
              alt=""
              width="52"
              height="52"
            />
            <p className="lgn-eyebrow mono">Back office</p>
            <h1 className="lgn-title" id="lgn-title">123High Admin</h1>
            <p className="lgn-sub">Sign in to manage content, users and the shop.</p>
          </header>

          <form className="lgn-form" onSubmit={login} noValidate={false}>
            <div className="lgn-field">
              <label className="lgn-label" htmlFor="lgn-un">User Name</label>
              <input
                className="lgn-input"
                id="lgn-un"
                name="username"
                type="text"
                placeholder="Enter user name"
                autoComplete="username"
                autoFocus
                required
                disabled={loginSuccess}
                aria-invalid={loginError || undefined}
                ref={UN}
              />
            </div>

            <div className="lgn-field">
              <label className="lgn-label" htmlFor="lgn-pwd">Password</label>
              <div className="lgn-pass">
                <input
                  className="lgn-input"
                  id="lgn-pwd"
                  name="password"
                  type={showPwd ? 'text' : 'password'}
                  placeholder="Enter password"
                  autoComplete="current-password"
                  required
                  disabled={loginSuccess}
                  aria-invalid={loginError || undefined}
                  ref={PWD}
                />
                <button
                  type="button"
                  className="lgn-reveal"
                  onClick={() => setShowPwd(v => !v)}
                  aria-pressed={showPwd}
                  aria-controls="lgn-pwd"
                  aria-label={showPwd ? 'Hide password' : 'Show password'}
                  title={showPwd ? 'Hide password' : 'Show password'}
                >
                  {showPwd ? (
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M17.9 17.9A10.1 10.1 0 0 1 12 20c-7 0-11-8-11-8a19.6 19.6 0 0 1 5.1-6M9.9 4.2A10.1 10.1 0 0 1 12 4c7 0 11 8 11 8a19.7 19.7 0 0 1-2.3 3.4M9.9 9.9a3 3 0 0 0 4.2 4.2" />
                      <path d="M2 2l20 20" />
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="lgn-live" role="status" aria-live="polite">
              {loginSuccess && (
                <p className="lgn-msg lgn-msg-good">
                  Welcome {userName}. Please wait...
                </p>
              )}

              {signedOutReason && !loginError && !loginSuccess && (
                <p className="lgn-msg">{signedOutReason}</p>
              )}

              {loginError && (
                <p className="lgn-msg lgn-msg-crit">
                  Login failed
                </p>
              )}
            </div>

            <Btn
              className="lgn-submit"
              variant="accent"
              type="submit"
              disabled={submitting || loginSuccess}
            >
              {submitting || loginSuccess ? (
                <>
                  <span className="lgn-spin" aria-hidden="true" />
                  Signing in...
                </>
              ) : 'Login'}
            </Btn>
          </form>
        </section>

        <p className="lgn-foot mono">onetwothreehigh.com</p>
      </main>
    </div>
  )
}
